// extracted by mini-css-extract-plugin
export default {"header":"header_header__q7YET","scrolled":"header_scrolled__TVNL1","notscrolled":"header_notscrolled__QI7Bq","mobileheader":"header_mobileheader__Kfuxf"};